/**
 * isola-country-selector.js
 * Wires up theme.Disclosure (assets/theme.js) on the new country/market selector
 * (snippets/isola-country-selector.liquid). Kept in a separate asset file so
 * assets/theme.js (Impulse core) is never touched — see CLAUDE.md "Don't override
 * Impulse theme core JS" rule. theme.HeaderSection / theme.FooterSection only
 * auto-wire their own hardcoded [data-disclosure-locale] / [data-disclosure-currency]
 * selectors, so [data-disclosure-country] needs its own init.
 *
 * Idempotent: safe to run more than once (e.g. the snippet is rendered in both the
 * header drawer and the footer, each emitting its own <script> tag for this file).
 */
(function () {
  function initIsolaCountrySelectors() {
    if (!window.theme || typeof theme.Disclosure !== 'function') return;

    var nodes = document.querySelectorAll('[data-disclosure-country]:not([data-isola-country-init])');
    nodes.forEach(function (node) {
      node.setAttribute('data-isola-country-init', 'true');
      new theme.Disclosure(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIsolaCountrySelectors);
  } else {
    initIsolaCountrySelectors();
  }

  // Re-init after Shopify theme editor re-renders header/footer sections.
  document.addEventListener('shopify:section:load', initIsolaCountrySelectors);
})();
